exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".spinner-background[data-v-30c18e50] {\n  display: flex;\n  align-items: center;\n  pointer-events: none;\n  width: 100vw;\n  height: 100vh;\n}\n.spinner-background .spinner[data-v-30c18e50] {\n  width: 16px;\n  height: 16px;\n}\n.spinner-background .spinner[data-v-30c18e50]:before {\n  left: -28px;\n  width: 16px;\n  height: 16px;\n}\n.spinner-background .spinner[data-v-30c18e50]:after {\n  left: 28px;\n  width: 16px;\n  height: 16px;\n}", ""]);

// exports
